import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { UserStatistic } from "@/core/services/api/interfaces/admin/UserStatistic";
import { TransactionStatistic as AdminTransactionStatistic } from "@/core/services/api/interfaces/admin/TransactionStatistic";
import { isUserAdmin } from "@/core/services/UserRoleService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";

const PlainTransactionStatistic = {
  total: 0,
  recent: 0,
  deposit: 0,
  withdraw: 0,
  fee: 0,
} as AdminTransactionStatistic;
const PlainUserStatistic = {
  total: 0,
  new: 0,
  active: 0,
} as UserStatistic;

@Module
export default class StatisticModule extends VuexModule {
  admin = {
    users: PlainUserStatistic,
    transactions: PlainTransactionStatistic,
  };

  get transactionsStatistic(): AdminTransactionStatistic {
    if (!isUserAdmin()) {
      return PlainTransactionStatistic;
    }

    return this.admin.transactions;
  }

  get usersStatistic(): UserStatistic {
    if (!isUserAdmin()) {
      return PlainUserStatistic;
    }

    return this.admin.users;
  }

  @Action({ rawError: true })
  [Actions.ADMIN_TRANSACTION_STATISTIC_LOAD]() {
    return ApiService.admin.transaction
      .statistic()
      .then(ApiService.unwrapItemResponse)
      .then((result) => {
        this.context.commit(Mutations.ADMIN_TRANSACTION_STATISTIC_SET, result);
      })
      .catch(console.error);
  }

  @Action({ rawError: true })
  [Actions.ADMIN_USER_STATISTIC_LOAD]() {
    return ApiService.admin.user
      .statistic()
      .then(ApiService.unwrapItemResponse)
      .then((result) => {
        this.context.commit(Mutations.ADMIN_USER_STATISTIC_SET, result);
      })
      .catch(console.error);
  }

  @Mutation
  [Mutations.ADMIN_TRANSACTION_STATISTIC_SET](statistics) {
    this.admin.transactions = statistics;
  }
  @Mutation
  [Mutations.ADMIN_USER_STATISTIC_SET](statistics) {
    this.admin.users = statistics;
  }
}
